import { Alert } from '@mantine/core'

import {
  useMutationCreateUserAddress,
  useMutationUpdateUserAddress,
} from '@flecto/core/shared'

export function AddressErrors() {
  const { error: errorCreate, isError: isErrorCreate } =
    useMutationCreateUserAddress()

  const { error: errorUpdate, isError: isErrorUpdate } =
    useMutationUpdateUserAddress()

  if (isErrorCreate || isErrorUpdate) {
    return (
      <Alert title='Bummer!' color='red'>
        {String(errorCreate)}
        {String(errorUpdate)}
      </Alert>
    )
  }

  return null
}
